module.exports = __webpack_public_path__ + "img/low.01f2f93d.svg";